import React from 'react';
import {Grid, Typography, Box} from '@mui/material';
import {
  Event as EventIcon,
  Notifications as NotificationsIcon,
  CalendarToday as CalendarIcon,
  DirectionsRun as DirectionsRunIcon
} from '@mui/icons-material';

import {useQuery} from '@apollo/client/react';
import {DASHBOARD_QUERY} from '../../services/gqlQueries';
import {LoadingSpinner, StatCard, RecentEvents, WaitingEntries, DashboardEvent, DashboardEntry} from './DashboardWidgets';

const Dashboard = () => {
  const {loading, data} = useQuery<{myEvents: DashboardEvent[]; waitingEntries: DashboardEntry[]}>(DASHBOARD_QUERY, {
    variables: {
      page: 1,
      size: 5
    }
  });

  if (loading) return <LoadingSpinner />;

  const events: DashboardEvent[] = data?.myEvents || [];
  const entries: DashboardEntry[] = data?.waitingEntries || [];

  // const quickActions = [
  //   {
  //     title: 'Create Event',
  //     description: 'Start a new event',
  //     icon: <AddIcon />,
  //     action: () => (window.location.href = '/my_events/add'),
  //     color: 'success' as const
  //   },
  //   {
  //     title: 'Manage Events',
  //     description: 'View and edit your events',
  //     icon: <EventIcon />,
  //     action: () => (window.location.href = '/my_events'),
  //     color: 'primary' as const
  //   },
  //   {
  //     title: 'Manage Competitors',
  //     description: 'Add and manage competitors',
  //     icon: <DirectionsRunIcon />,
  //     action: () => (window.location.href = '/competitors'),
  //     color: 'secondary' as const
  //   },
  //   {
  //     title: 'System Settings',
  //     description: 'Configure system settings',
  //     icon: <SettingsIcon />,
  //     action: () => (window.location.href = '/configurations'),
  //     color: 'info' as const
  //   }
  // ];

  return (
    <Box sx={{flexGrow: 1, width: '100%'}}>
      <Typography variant="h4" gutterBottom>
        Dashboard
      </Typography>

      {/* Statistics Cards */}
      <Grid container spacing={{xs: 1, sm: 2, md: 3}} sx={{mb: {xs: 2, sm: 3, md: 4}}}>
        <Grid size={{xs: 6, md: 3}}>
          <StatCard title="Total Events" value={events.length} icon={<EventIcon />} color="primary" />
        </Grid>
        <Grid size={{xs: 6, md: 3}}>
          <StatCard title="Waiting Entries" value={entries.length} icon={<NotificationsIcon />} color="warning" />
        </Grid>
        <Grid size={{xs: 6, md: 3}}>
          <StatCard
            title="Active Events"
            value={events.filter((e: DashboardEvent) => e.status === 'ACTIVE').length}
            icon={<CalendarIcon />}
            color="success"
          />
        </Grid>
        <Grid size={{xs: 6, md: 3}}>
          <StatCard
            title="Total Competitors"
            value={events.reduce((acc: number, event: DashboardEvent) => acc + (event.competitors?.length || 0), 0)}
            icon={<DirectionsRunIcon />}
            color="secondary"
          />
        </Grid>
      </Grid>

      {/* Quick Actions */}
      {/* <Grid container spacing={3} sx={{mb: 4}}>
        <Grid item xs={12}>
          <Typography variant="h5" gutterBottom>
            Quick Actions
          </Typography>
        </Grid>
        {quickActions.map((action, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <QuickActionCard {...action} />
          </Grid>
        ))}
      </Grid> */}

      {/* Main Content */}
      <Grid container spacing={{xs: 1, sm: 2, md: 3}}>
        <Grid size={{xs: 12, lg: 6}}>
          <RecentEvents />
        </Grid>
        <Grid size={{xs: 12, lg: 6}}>
          <WaitingEntries />
        </Grid>
      </Grid>
    </Box>
  );
};

export default Dashboard;
